import request from '@/utils/request'

const tradeUserApi = {
  tradeUserList: '/trade/user/',
  tradeUserCreate: '/trade/user/',
  tradeUserUpdate: '/trade/user/',
  tradeUserDelete: '/trade/user/',
  tradeUserExport: '/trade/user/export/',
  tradeUserDepartmentList: '/trade/user_department/',
  tradeUserDepartmentCreate: '/trade/user_department/',
  tradeUserDepartmentUpdate: '/trade/user_department/',
  tradeUserDepartmentDelete: '/trade/user_department/'
}

/**
 * 列表
 */
export function tradeUserList (parameter) {
  return request({
    url: tradeUserApi.tradeUserList,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function tradeUserCreate (parameter) {
  return request({
    url: tradeUserApi.tradeUserCreate,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function tradeUserUpdate (parameter, trade_user_id) {
  return request({
    url: tradeUserApi.tradeUserUpdate + trade_user_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function tradeUserDelete (trade_user_id) {
  return request({
    url: tradeUserApi.tradeUserDelete + trade_user_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function exportUser () {
  return request({
    url: tradeUserApi.tradeUserExport,
    method: 'get',
    headers: {
      'Content-Type': 'application/octet-stream'
    },
    responseType: 'blob'
  })
}

/**
 * 列表
 */
export function tradeUserDepartmentList (parameter) {
  return request({
    url: tradeUserApi.tradeUserDepartmentList,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加
 */
export function tradeUserDepartmentCreate (parameter) {
  return request({
    url: tradeUserApi.tradeUserDepartmentCreate,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

export function tradeUserDepartmentUpdate (parameter, trade_user_role_id) {
  return request({
    url: tradeUserApi.tradeUserDepartmentUpdate + trade_user_role_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function tradeUserDepartmentDelete (trade_user_role_id) {
  return request({
    url: tradeUserApi.tradeUserDepartmentDelete + trade_user_role_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
